export default __webpack_public_path__ + "media/images/favicon/cube_tiny-08f3d43b828e99104cc3c54f9646a0d9.png";